// TOOD: https://babeljs.io/docs/en/babel-plugin-transform-regenerator
import 'babel-polyfill'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Env from './plugins/env'
import Keycloak from './plugins/keycloak'

Vue.config.productionTip = false

getEnv().then((env) => {
  Vue.use(Env, env)
  Vue.use(Keycloak)
  require('./main.js')
}).catch(function (err) {
  document.body.innerHTML = '<p>Bootstrap failed: ' + err.message + '</p>'
  console.error('Bootstrap failed:', err)
})

function getEnv () {
  if (process.env.NODE_ENV === 'testing') return Promise.resolve({})

  return new Promise(function (resolve, reject) {
    // http://youmightnotneedjquery.com/#json
    const request = new XMLHttpRequest()
    console.info('[boot] requesting config.json')
    request.open('GET', 'config.json', true)
    request.onload = function () {
      if (request.status >= 200 && request.status < 400) {
        // Success!
        console.info('[boot] config.json found')
        const data = JSON.parse(request.responseText)
        resolve(data)
      } else if (request.status === 404) {
        // In case there is no config.json, we procee
        console.info('[boot] config.json not found')
        resolve({})
      } else {
        console.info('[boot] config.json request failed with ' + request.status)
        reject(request.status)
      }
    }
    request.onerror = function () {
      console.info('[boot] config.json request failed')
      reject(new Error('Connection error'))
      // There was a connection error of some sort
    }
    request.send()
  })
}



// WEBPACK FOOTER //
// ./src/boot.js